import React from 'react'
import { UsersList } from './list/page'

export const UsersPage = (): JSX.Element => {
  return <UsersList />
}
